module.exports = __webpack_public_path__ + "static/media/shovel.fdc887d7.svg";